import React from "react";
import classnames from "classnames";
import s from "./SingleCheckbox.module.scss";
import { UncontrolledTooltip } from "reactstrap";

const SingleCheckbox = ({
  text,
  checked,
  onChange,
  disabled = false,
  tooltip,
  id,
  extraClassName,
  containerClassName,
  checkboxClassName,
}) => {
  return (
    <div className={classnames(s.ContainerDiv, containerClassName)}>
      <label className={classnames(s.Container, extraClassName)}>
        <span className={classnames(disabled && s.DisabledCheckbox)}>
          {text}
        </span>
        <input
          type="checkbox"
          onChange={onChange}
          checked={checked}
          disabled={disabled}
          id={id}
        />
        <span
          className={classnames(
            s.Checkmark,
            [disabled && s.DisabledCheckbox],
            checkboxClassName
          )}
        ></span>
        {tooltip && (
          <>
            <span className="ml-2">
              <i
                className={classnames("fa fa-info-circle", s.infoIcon)}
                id={id}
              ></i>
            </span>
            <UncontrolledTooltip placement="right" target={id}>
              {tooltip}
            </UncontrolledTooltip>
          </>
        )}
      </label>
    </div>
  );
};

export default SingleCheckbox;
